module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGGyumaoC-b10dacf5f199ba9531394671df2a437d.png";